import script from "./PlanCard.vue?vue&type=script&setup=true&lang=js"
export * from "./PlanCard.vue?vue&type=script&setup=true&lang=js"

import "./PlanCard.vue?vue&type=style&index=0&id=40b2759e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-40b2759e"]])

export default __exports__